import { db, admin } from "common/config/Firebase"
import createIds from "./createIds"

const indicatorsByDay = db.collection('indicatorsByDay')
const indicatorsByMonth = db.collection('indicatorsByMonth')

const newTask = (task) => {
    const date = new Date()

    if (task.isNewClient) {
        const increment = admin.firestore.FieldValue.increment(1)
        indicatorsByDay.doc(createIds.createIdByDay(date)).set({ taskByNewClient: increment }, { merge: true })
        indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ taskByNewClient: increment }, { merge: true })
        return
    }

    const increment = admin.firestore.FieldValue.increment(1)
    indicatorsByDay.doc(createIds.createIdByDay(date)).set({ taskByOldClient: increment }, { merge: true })
    indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ taskByOldClient: increment }, { merge: true })
}

export default {
    newTask
}